import COMMON_SENSE from './common-sense'

export default {
  COMMON_SENSE,
  'FRONT_END_PAGES': {
    data() {
      return {
        frontEndPageConfig: {
          list: [], // 所有数据的列表
          count: 0, // 列表总数
          page: 1, // 页码
          pageSize: 10, // 页数据大小
          filterList: [], // 过滤后的数据列表
          displayList: [], // 展示数据的列表
          selectedChange: null, // 当行选择后触发的方法
          allKeyForFilter: false, // 是否开启全字段搜索
          filterKeyForFilter: false, // 是否开启特定字段搜索
          keyword: '', // 搜索关键字
          skipKeyList: [], // 过滤关键字
          filterKeyList: [], // 搜索特定字段列表
        }
      }
    },
    methods: {
      //初始化分页数据
      frontEndPagesReset() {
        this.frontEndPageConfig.page = 1;
        this.frontEndPageConfig.count = 0;
        this.frontEndPageConfig.pageSize = 10;
        this.frontEndPageConfig.list = []
      },
      // 建立前端分页
      createFrontEndPages(allData) {
        this.frontEndPageConfig.list = allData;
        this.frontEndPageConfig.count = this.frontEndPageConfig.list.length;
        this.frontEndPageConfig.filterList = this.frontEndPageConfig.list;
        this.displayCurrPageList();
      },
      // 展示当前页数的数据
      displayCurrPageList() {

        const startIndex = (this.frontEndPageConfig.page - 1) * this.frontEndPageConfig.pageSize;
        const endIndex = this.frontEndPageConfig.pageSize * this.frontEndPageConfig.page;

        this.frontEndPageConfig.displayList = [];

        let tempDisplayList = [];
        for (let i=startIndex; i<endIndex; i++) {
          if (!this.frontEndPageConfig.filterList[i]) break;
          tempDisplayList.push(this.frontEndPageConfig.filterList[i]);
        }

        this.frontEndPageConfig.displayList = [...tempDisplayList];

      },
      // 前端查询
      queryFrontEndPagesListWithKeyword() {
        this.frontEndPageConfig.filterList = this.filterListWithKeyword();
        this.frontEndPageConfig.page = 1;
        this.frontEndPageConfig.count = this.frontEndPageConfig.filterList.length;

        this.displayCurrPageList(); // 展示数据

        this.$nextTick(() => {
          this.frontEndPageConfig.selectedChange && this.frontEndPageConfig.selectedChange(); // 回调方法
        })
      },
      /**
       * 前端筛选
       * @param {Array} list 所有数据的列表
       * @param {Boolean} allKeyForFilter 是否开启全字段搜索
       * @param {Boolean} filterKeyForFilter 是否开启特定字段搜索
       * @param {String} keyword 搜索关键字
       * @param {Array} skipKeyList 跳过搜索的关键字
       * @param {Object[]} filterKeyList 搜索特定字段列表
       * @param {String} filterKeyList[].matchKey 特定字段
       * @param {*} filterKeyList[].matchValue 特定字段匹配值
       * @param {Function} filterKeyList[].customMatch 特定字段匹配方法 必须返回boolean
       */
      filterListWithKeyword() {
        const { list, allKeyForFilter, filterKeyForFilter } = this.frontEndPageConfig;
        return list.filter((item) => {

          const allKeyForFilterResult = allKeyForFilter && (this.filterForAllKeys(item));

          const filterKeyForFilterResult = filterKeyForFilter && (this.filterForFilterKeys(item));

          return (allKeyForFilter && allKeyForFilterResult) || (filterKeyForFilter && filterKeyForFilterResult)

        });
      },
      // 搜索全字段
      filterForAllKeys(item) {
        const {skipKeyList, keyword} = this.frontEndPageConfig;

        for (let key in item) {
          if (this.skipKeyFromKeys(key, skipKeyList)) {
            continue;
          }
          let queryItem = '' + item[key];
          if (queryItem.toUpperCase().indexOf((keyword).toUpperCase()) !== -1) {
            return true;
          }
        }
        return false;
      },
      // 判断字段是否搜索跳过
      skipKeyFromKeys() {
        const {skipKey, skipKeyList} = this.frontEndPageConfig

        let isSkip = false;

        for (let i = 0; i < skipKeyList.length; i++) {
          const key = skipKeyList[i];
          if (key == skipKey) {
            isSkip = true;
            break;
          }
        }

        return isSkip;
      },
      // 搜索特定字段
      filterForFilterKeys(item) {
        const {filterKeyList} = this.frontEndPageConfig
        for (let i = 0; i < filterKeyList.length; i++) {
          const {
            matchKey,
            matchValue,
            customMatch
          } = filterKeyList[i];

          // 如果存在自定义匹配方法
          if (customMatch) {

            let result = customMatch();
            if (result === false) {
              return false;
            }
          }

          if (item[matchKey] !== matchValue) {
            return false
          }
        }

        return true;

      },
      // 翻页
      changeFrontEndPagesPage(pageIndex) {
        this.frontEndPageConfig.page = pageIndex;
        this.displayCurrPageList();
  
        this.$nextTick(() => {
          this.frontEndPageConfig.selectedChange && this.frontEndPageConfig.selectedChange();
        })
      },
      // 改变页码
      changeFrontEndPagesPageSize(pageSize) {
        this.frontEndPageConfig.page = 1;
        this.frontEndPageConfig.pageSize = pageSize;
        this.displayCurrPageList();
  
        this.$nextTick(() => {
          this.frontEndPageConfig.selectedChange && this.frontEndPageConfig.selectedChange();
        })
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js